import { useMemo } from "react";
import { useAppSelector } from "Store/hooks";
import { selectOrganization } from "../redux/selectors";
import { columns } from "./columns/columns";
import { Table } from "antd";

interface OrganizationsTableProps {
  searchText?: string;
}

const OrganizationsTable = ({ searchText = "" }: OrganizationsTableProps) => {
  const organizationsList = useAppSelector(selectOrganization);

  const filteredList = useMemo(() => {
    if (!searchText.trim()) return organizationsList;
    const term = searchText.toLowerCase();
    return organizationsList?.filter((org: any) =>
      org.name?.toLowerCase().includes(term)
    );
  }, [organizationsList, searchText]);

  return (
    <Table
      style={{ padding: "0px" }}
      columns={columns}
      dataSource={filteredList}
    />
  );
};
export default OrganizationsTable;
